<template>
  <div>
    <div class="quize-time-section">
      <div class="quize-time-section-container d-flex justify-content-between align-items-center">
        <h1 class="font-20 mb-0"><b>{{ activeQuiz.title }}</b></h1>
        <div class="d-flex align-items-center m-auto" v-if="activeQuiz.time_limit">
          <div class="clock">
            <div class="clock-cup clock-top">
              <div class="clock-sand"></div>
            </div>
            <div class="clock-cup">
              <div class="clock-sand delayed"></div>
            </div>
          </div>
          <timer/>
        </div>
        <span class="d-none open-quize-des"><i class="menu-arrow"></i>{{ trans('description') }}</span>
      </div>
    </div>
    <section class="quiz-page">
      <div class="quiz-container">
        <div v-if="showContactFields" class="form-group quiz-block">
          <p class="quiz-title">1. {{ trans('user full name') }}</p>

          <input type="text" name="name" class="form-control" @input="setName($event.target.value)" :value="getName">
        </div>

        <div v-if="showContactFields" class="form-group quiz-block">
          <p class="quiz-title">2. {{ trans('Email') }}<span> *</span></p>

          <input type="text" name="email" class="form-control" @input="setEmail($event.target.value)" :value="getEmail">
        </div>

        <one-question v-for="(question, index) in activeQuiz.questions"
                      :question="question"
                      :index="showContactFields ? index + 2 : index"
                      :key="question.id"/>

        <div v-if="userId || activeQuiz.no_need_auth" class="text-center mt-5">
          <button type="submit" class="btn btn-1" @click="onConfirmHandler">
            {{ activeQuiz.submit_button_text }}
          </button>
        </div>

        <div v-else class="text-center mt-5">
          <button
              type="submit"
              class="btn btn-1 tooltip-info disabled"
              data-toggle="tooltip"
              data-placement="top"
              :title="trans('please first login')">
            {{ activeQuiz.submit_button_text }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Timer from "./Timer";
import OneQuestion from "./OneQuestion";
import {mapMutations} from "vuex";

export default {
  props: ['userId'],
  name: "AllQuestionsOnePage",
  components: {
    'timer': Timer,
    'one-question': OneQuestion
  },
  computed: {
    getEmail() {
      return this.$store.state.email;
    },
    getName() {
      return this.$store.state.name;
    },
    isLoggedIn() {
      return !!this.userId;
    },
    // Name/email are only collected for guests. A logged-in user's name/email
    // already come from their account on the backend, so we hide the fields and
    // autofill the store instead of asking them again.
    showContactFields() {
      return (this.activeQuiz.send_email_after_submit || this.activeQuiz.collect_emails)
        && !this.isLoggedIn;
    }
  },
  methods: {
    ...mapMutations(['setEmail', 'setName'])
  },

  mounted() {
    if (this.isLoggedIn && window.formAuthUser) {
      if (!this.getName) {
        this.setName(window.formAuthUser.name || '');
      }
      if (!this.getEmail) {
        this.setEmail(window.formAuthUser.email || '');
      }
    }

    $('[data-toggle="tooltip"]').tooltip()
  }
}
</script>
